import { Box } from "@mui/system";

export const NoMenu = ( { page, dataTest }: { page: JSX.Element, dataTest: string }): JSX.Element => 
    <Box sx={{backgroundColor:'hsl(0, 0%, 80%)' }}>
        <Box sx={{ maxWidth:640, margin:"auto", backgroundColor:'white', padding:"4vh", minHeight:"100vh" }} data-test={dataTest}>
            {page}
        </Box>
    </Box>